export * from './baMenuItem.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baMenu/components/baMenuItem/index.ts